(function () {
    'use strict';

    angular.module('swif.parcauto')
    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/parcauto/statistics', {
            templateUrl: 'partials/openstc/tasks_statistics_view.html',
            controller: 'TasksStatisticsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check({resources: ['d3']});
                }]
            }
        });
    }]);

})();
